<template>
    <div dir="rtl">
        <router-view name="navbar"></router-view>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: 'Index',
  mounted: function () {
    document.body.classList.add('rtl')
  }
}
</script>
<style lang="scss" >
    @import '../assets/scss/rtl.scss';
</style>